import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { AudioService } from '@app/audio/audio.service';
import { LoadingComponent } from '@app/shared/components/loading/loading.component';
import { AvoidMulticlickDirective } from '@app/shared/directives/avoid-multiclick.directive';
import { ButtonAudioType } from '@app/shared/models/button-audio.model';

@Component({
  selector: 'slotcom-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AvoidMulticlickDirective, LoadingComponent],
})
export class ButtonComponent {
  @Input() id: number | string = null;
  @Input() isDisabled = false;
  @Input() isLoading = false;
  @Input() name: number | string = null;
  @Input() tabIndex = 0;
  @Input() testId: number | string = null;
  @Input() type = 'button';
  @Input() audioType: ButtonAudioType = 'default';

  @Output() safeClick = new EventEmitter<MouseEvent>();

  private readonly audioService = inject(AudioService);

  onSafeClick(event: MouseEvent) {
    if (this.isDisabled || this.isLoading) {
      return;
    }

    this.audioService.playButtonAudio(this.audioType);
    this.safeClick.emit(event);
  }
}
